import {DEFAULT_PAGE_SIZE} from 'app/utils/constants';

interface Props {
  objectId?: string | number;
  page?: string;
  page_size?: string;
}

export function convertParamsForVersionsQuery(query: Props) {
  return {
    objectId: query.objectId ?? '1',
    page: query.page ?? '1',
    page_size: query.page_size ?? `${DEFAULT_PAGE_SIZE}`,
  };
}
